import React, { useState } from 'react';
import { Button, Typography, Box } from '@mui/material';
import { DeleteOutlined } from '@mui/icons-material';

const InboxPage = () => {
  const [messages, setMessages] = useState([
    {
      id: 1,
      content: 'Carrier Targeting Revamp\n\nWe have updated the platform\'s mobile carrier names to comply with the most recent brand names. We encourage you to make sure that your carrier-targeting campaigns are setup as planned.\n\nJust as a quick reminder - carrier targeting allows you to show your campaigns on mobile devices running under specific mobile operators.',
    },
    {
      id: 2,
      content: 'Buy Search Traffic and eCommerce Traffic\n\nWe have added two new great targeting option to our Injection Traffic (Contextual Pops):\n\nEnable SERP (Run Of Search) - Choose the keyword run_of_serp to buy all of the Injection SEARCH traffic. Use the macro {BV_KEYWORD} to pass the search keyword to your landing page.\n\nEnable ECOM (Run Of eCommerce) - Choose the keyword run_of_ecom to buy all of the Injection SEARCH traffic from eCommerce stores only (Amazon, ebay, AliExpress, Asos etc). Use the macro {BV_KEYWORD} to pass the search keyword to your landing page.',
    },
  ]);

  const removeMessage = (id: number) => {
    setMessages(messages.filter(message => message.id !== id));
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Message Board
      </Typography>

      {messages.map((message) => (
        <Box key={message.id} sx={{ marginBottom: 3, padding: 2, border: '1px solid #ddd', borderRadius: 2 }}>
          <Typography variant="h6" paragraph>
            <strong>Click here to read more...</strong>
          </Typography>
          <Typography paragraph>{message.content}</Typography>
          <Button
            variant="contained"
            color="error"
            startIcon={<DeleteOutlined />}
            onClick={() => removeMessage(message.id)}
            sx={{ marginTop: 2 }}
          >
            Remove Message
          </Button>
        </Box>
      ))}
    </Box>
  );
};

export default InboxPage;
